import { DestroyRef, Injectable, computed, inject, signal } from '@angular/core';

@Injectable()
export class VisitContext {
  readonly decision = signal<'pending' | 'approved' | 'rejected'>('pending');
  readonly step = signal(2);
  readonly updates = signal<readonly string[]>([]);
  readonly result = computed(() => ({ pending: 'Esperando tu autorización.', approved: 'Visita autorizada en la demo.', rejected: 'Visita rechazada. Aviso simulado para la caseta.' })[this.decision()]);
  private timers: ReturnType<typeof setTimeout>[] = [];
  constructor() { inject(DestroyRef).onDestroy(() => this.clear()); }
  private clear(): void { this.timers.forEach(clearTimeout); this.timers = []; }
  approve(): void {
    if (this.decision() !== 'pending') return;
    this.decision.set('approved'); this.step.set(3);
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.timers.push(setTimeout(() => this.updates.update(items => ['✓ Entrada registrada · 18:42 · LNR-482-B · Evidencia simulada.', ...items]), reduced ? 0 : 700));
    this.timers.push(setTimeout(() => { this.updates.update(items => ['✓ Salida registrada · 20:15 · Visita cerrada.', ...items]); this.step.set(4); }, reduced ? 0 : 2500));
  }
  reject(): void { if (this.decision() === 'pending') this.decision.set('rejected'); }
  reset(): void { this.clear(); this.decision.set('pending'); this.step.set(2); this.updates.set([]); }
}
